export default __webpack_public_path__ + "static/media/Scene 7.58fd8fd6.webp";